// extracted by mini-css-extract-plugin
export default {"container":"Header-module__container__w6M5R7O"};